module.exports = __webpack_public_path__ + "static/media/groupOfPeople.6a89770b.svg";